export default {
  tenantRole: {
    PLATFORM_OPERATOR: "Platformbetreiber",
    PLANT_OPERATOR: "Anlagenbetreiber",
    RESCUE_SERVICE: "Rettungsstelle",
    SERVICE_COMPANY: "Serviceunternehmen",
  },
  approvalStatus: {
    PENDING: "Ausstehend",
    APPROVED: "Genehmigt",
    DENIED: "Abgelehnt",
    PENDING_INVITATION: "Einladung ausstehend",
    WITHOUT_EA_APPROVAL: "Ohne EA-Genehmigung",
  },
};
